<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-13 12:19:47
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 10:59:34
 * @name: 更换销售
 * @Description: 更换销售
 * @FilePath: \preSaleNafterSaleBackstage\src\components\pianoCompanyManage\dialog\update-saler.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div>
    <addNeditDialog ref="addNeditDialog" title="更换销售" @close="close">
      <template v-slot:form>
        <div class="line">
          <font class="label"><i class="warn">*</i>请选择更换销售员:</font>
          <el-select
            class="input"
            v-model="saler_id"
            placeholder="请选择更换销售员"
          >
            <el-option
              v-for="item of pianoCompany.salers"
              :key="item.id"
              :label="item.realname"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
      </template>
      <template v-slot:btnGroup>
        <el-button class="submit" type="primary" @click="submit"
          >确认</el-button
        >
      </template>
    </addNeditDialog>
  </div>
</template>
<script>
import addNeditDialog from "@/components/pianoCompanyManage/dialog/addNeditDialog.vue";
import { debounceation } from "@/utils/decorator";

export default {
  name: "pianoCompanyManage-updateSaler",
  components: {
    addNeditDialog,
  },
  props: {
    pianoCompany: {
      type: Object,
    },
  },
  data() {
    return {
      selectRow: [], //琴行表格选中项
      saler_id: "", //销售id
    };
  },
  computed: {
    // 验证跟进销售是否已选
    saler_id_match() {
      return this.saler_id === "";
    },
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 初始化data
     */
    initData() {
      this.selectRow = [];
      this.saler_id = "";
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 打开弹窗
     * @param {Array} selectRow 琴行表格选中项
     */
    open(selectRow) {
      this.selectRow = selectRow;
      this.$refs.addNeditDialog.open();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 关闭弹窗回调
     */
    close() {
      this.initData();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 关闭弹窗
     */
    @debounceation(300)
    cancel() {
      this.$refs.addNeditDialog.close();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击确认
     */
    @debounceation(300)
    submit() {
      if (this.saler_id_match) {
        this.$message.error("请选择更换销售!");
        return;
      }
      this.$emit("updateSaler", {
        selectRow: this.selectRow,
        saler_id: this.saler_id,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.line {
  margin-bottom: 20px;
  width: 100%;
  height: $Var-height-mormal;
  @extend .extend-flex-start;
  .label {
    font-size: $Vars-font-miniTitle-size;
    color: $Vars-font-normal-color;
    text-align: left;
    flex-shrink: 0;
    margin-right: 20px;
    position: relative;
    .warn {
      position: absolute;
      left: -10px;
      content: "*";
      color: red;
    }
  }
  .input {
    flex: 1;
  }
}
.submit {
  width: $Var-button-width-normal;
}
</style>